export default __webpack_public_path__ + "static/media/005.0c8b745f.svg";